import React, { useState } from 'react';
import { Button, FormLabel, FormGroup, FormControl, Form, Col } from 'react-bootstrap';
import TwitterPicker from 'react-color/lib/components/twitter/Twitter';
import ApiService from '../../services/ApiService';

const TagCreateForm = ({ callback, onCancel, hideCancel = false }) => {
  const [tagLabel, setTagLabel] = useState('');
  const [tagColor, setTagColor] = useState('#CCCCCC');

  const handleNewTagLabelChange = event => {
    setTagLabel(event.target.value);
  };

  const handleNewTagColorChange = (color, event) => {
    setTagColor(color.hex);
  };

  const handleNewTagClick = () => {
    return ApiService.put('tag', { tagLabel, tagColor }).then(response => {
      if (callback) {
        callback(response.data);
      }
    });
  };

  return (
    <div className="tag-create-form">
      <Form>
        <Form.Row className="align-items-center justify-content-center">
          <Col xs="auto">
            <FormGroup className="mb-1">
              <FormLabel>Create New Tag</FormLabel>
              <FormControl type="text" placeholder="Enter Label" onChange={handleNewTagLabelChange} />
            </FormGroup>
            <TwitterPicker triangle="hide" onChange={handleNewTagColorChange} color={tagColor} />
          </Col>
          <Col xs="auto" style={{ width: '50px', alignSelf: 'start' }}>
            <Button variant="success" className="mb-1" disabled={tagLabel === ''} onClick={handleNewTagClick}>
              <i className="fas fa-check fa-fw" />
            </Button>
            {!hideCancel && (
              <Button variant="secondary" onClick={onCancel} title="Cancel">
                <i className="fas fa-times fa-fw" />
              </Button>
            )}
          </Col>
        </Form.Row>
      </Form>
    </div>
  );
};

export default TagCreateForm;
